import {
  SETTINGS_REQUEST,
  SETTINGS_SUCCESS,
  SETTINGS_FAILURE,
} from './SystemActions';

const initialState = {
  loading: false,
  data: {},
};

export default (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SETTINGS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        ...payload,
      };
    }
    case SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
